export const INITIAL_STATE = {};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/DAILY_RETURNS":
            return {...state, ...action.payload};
        case "SUBSCRIPTION_ENDED/DAILY_RETURNS":
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default dispatch => ({});
